import { client } from '@atlassian/rovo-content-bridge-api';
export var HELP_CENTER_FORM_REQUEST_CLIENT_ID = client('help-center-form-content-renderer');